export default __webpack_public_path__ + "static/media/blog-oil-stain-001.9e8f3f11.jpg";